<script>
import * as d3 from 'd3'
import $ from 'jquery'
import setting from '@/setting.js'
import {mapGetters} from "vuex"
// import common from '@/common.js'

export default {
    props: ['ball', 'mode', 'allBalls', 'baseBallIndex', 'savedBalls', 'currentAngle', 'slideBatx', 'slideBaty', 'slideBatz', 'slidePitx', 'slidePity', 'slidePitz', 'currentBatterPointSet', 'batterPanelState', 'pitcherPanelState', 'savedStandardBall', 'base', 'compar', 'PTReviewStandardBall', 'threeListSortMode'],
    emits: ['submit-pitcher-point', 'submit-pitcher-position', 'submit-batter-point', 'submit-batter-position', 'close-pitcher-panel', 'close-batter-panel', 'reset-ward', 'get-saved-standard-balls', 'change-pitcher-point', 'change-pitcher-position', 'change-batter-point', 'change-ward', 'open-search-modal', 'toggle-saved-standard-ball', 'get-saved-balls','change-mode'],
    data() {
        return {
            setting,
            opened: true,
            slideParamsx1: 0,
            slideParamsy1: 0,
            slideParamsz1: 0,
            slideParamsx2: 0,
            slideParamsy2: 0,
            slideParamsz2: 0,
            defaultParamsx1: 0,
            defaultParamsy1: 0,
            defaultParamsz1: 0,
            defaultParamsx2: 0,
            defaultParamsy2: 0,
            defaultParamsz2: 0,
            currentParamsx: 0,
            currentParamsz: 0,
            currentParamsy: 0,
            currentParamsx2: 0,
            currentParamsy2: 0,
            boxParamsx: 0,
            boxParamsz: 0,
            inputParamsx: 0,
            inputParamsz: 0,
            inputParamsy: 0,
            inputParamsx2: 0,
            inputParamsy2: 0,
            beforeAfterFlg: false,
            leftRightFlg: false,
            leftRightPitcherFlg: false,
            inputDefaultParamsx: 0,
            inputDefaultParamsz: 0,
            inputDefaultParamsy: 0,
            inputDefaultParamsx2: 0,
            inputDefaultParamsy2: 0,
            defaultBeforeAfterFlg: false,
            defaultLeftRightFlg: false,
            defaultLeftRightPitcherFlg: false,
            batterInputState: 0,
            pitcherInputState: 0,
            batterInputDisabled: false,
            batterPositionIsValid: false,
            batterPointIsValid: false,
            pitcherPositionIsValid: false,
            pitcherPointIsValid: false,
            width: 48,
            height: 72,
            xMin: -159.76,
            xMax: -36.84,
            xMin2: 36.84,
            xMax2: 158.76,
            yMin: 1730.96,
            yMax: 1913.84
        }
    },
    computed: {
        ...mapGetters(['listOfTeams']),
        xScale () {
            return d3.scaleLinear().domain([this.xMax, this.xMin]).range([this.width, 0])
        },
        xScale2 () {
            return d3.scaleLinear().domain([this.xMax2, this.xMin2]).range([this.width, 0])
        },
        yScale () {
            return d3.scaleLinear().domain([this.yMin, this.yMax]).range([0, this.height])
        },
        comparativeStandardBall () {
            if (this.threeListSortMode === 2) {
                return this.PTReviewStandardBall
            } else {
                return this.savedStandardBall
            }
        }
    },
    watch: {
        slideParamsy1: 'changeBatterPoint',
        slideParamsx2: 'changePitcherPosition',
        slideParamsy2: 'changePitcherPoint',
        currentAngle: 'changeSlideParams',
        beforeAfterFlg: 'batterPositionValid',
        leftRightFlg: 'batterPositionValid',
        leftRightPitcherFlg: 'pitcherPositionValid'
    },
    mounted() {
        this.changeSlideParams()
    },
    methods: {
        open () {
            console.log('opens')
            this.opened = true
            $('.infoWrapper').css('max-height', '500px')
            $('.info').fadeIn()
        },
        close () {
            console.log('close')
            this.opened = false
            $('.infoWrapper').css('max-height', '0px')
            $('.info').fadeOut()
        },
        setBaseBallInfo (type) {
            // 選択されている基準球をピッチトンネルの基準球としてセット
            let ball = null
            if (type === 'compare') {
                this.addPitchTunnel(this.savedStandardBall[0].data)
                ball = this.savedStandardBall[0].data
                // common.LOG('INFO', '3D軌跡 比較モード トップ', '基準球 ピッチトンネルモード基準球として登録', ball.id, ball.Pitcher.name)
            } else if (type === 'atBat') {
                this.addPitchTunnel(this.ball.data)
                ball = this.ball.data
                // common.LOG('INFO', '3D軌跡 打席モード トップ', '基準球 ピッチトンネルモード基準球として登録', ball.id, ball.pitchingdata.Pitcher)
            }
        },
        getBallType (mode) {
            if (mode === 'compare') {
                //$vm0.savedStandardBall[0].data
                if (this.savedStandardBall.length === 0) return
                switch (this.savedStandardBall[0].data.pitchingdata.TaggedPitchType) {
                case 'Fastball':
                case 'Sinker':
                case 'Cutter':
                    return false
                default:
                    return true
                }
            }
            if (Object.keys(this.ball).length === 0) return
            switch (this.ball.data.pitchingdata.TaggedPitchType) {
            case 'Fastball':
            case 'Sinker':
            case 'Cutter':
                return false
            default:
                return true
            }
        },
        addPitchTunnel (data) {
            switch (data.pitchingdata.TaggedPitchType) {
            case 'Fastball':
            case 'Sinker':
            case 'Cutter':
                break
            default:
                return
            }

            const tabData = this.$ls.get(this.setting.sessionKey.pt1Tabs)
            if (tabData.data.length >= 5) {
                if (window.confirm('ピッチトンネルが作成できません。 \n' +
                    '作成できる件数は最大5件ですので \n既存のピッチトンネルのデータを削除してください。\n' +
                    'PT1に遷移しますか？')) {
                    this.$emit('change-mode', 'tunnel')
                    return
                } else {
                    return
                }
            }

            const allNameList = this.$p.get(data.pitchingdata.PitcherTeam)
            const arm = (() => {
                if (data.pitchingdata.PitcherThrows === 'Right') return '右'
                else if (data.pitchingdata.PitcherThrows === 'Left') return '左'
                else return ''
            })()
            const pt2Data = {
                selectedYear: data.pitchingdata.Date.split('/')[2],
                selectedMonth: data.pitchingdata.Date.split('/')[0],
                selectedLeague: this.listOfTeams[data.pitchingdata.PitcherTeam].league,
                teams: [{
                    value: data.pitchingdata.PitcherTeam,
                    text: this.listOfTeams[data.pitchingdata.PitcherTeam].name_short2,
                }],
                selectedLevel: data.pitchingdata.Level,
                selectedTeam: data.pitchingdata.PitcherTeam,
                pitchers: [{
                    value: data.pitchingdata.PitcherId,
                    text: allNameList[data.pitchingdata.PitcherId].name,
                    arm: arm,
                }],
                selectedArm: arm,
                selectedPitcher: data.pitchingdata.PitcherId,
                selectedBall1: data.pitchingdata.TaggedPitchType,
                checkBoxs: [],
                otherScreenAddFlag: true,
                selectedBall1Id: data.id,
            }
            this.initLocalStorage()
            const ptData = this.$ls.get(this.setting.sessionKey.pt1Tabs)
            ptData.index = ptData.data.length
            this.$ls.set(setting.sessionKey.pt1Tabs, ptData)
            this.$ls.set(this.setting.sessionKey.pt2Search, pt2Data)
            this.$router.push('PitchiTunnelSearch')
        },
        initLocalStorage () {
            // PT2Hシークバー初期化
            this.$ls.set(this.setting.sessionKey.pt2ChangeAmountThresholdSeekBar, {
                ptX: 14.6, // PT円の横幅
                ptY: 14.6, // PT円の縦幅
                hpY: 51.1, // HP円の縦幅
                hpX: 51.1, // HP円の横幅
                ptMaxUp: 29.2, //PT上限値の上の方
                ptMaxDown: 3.65, // PT上限値の下の方
                hpMaxUp: 51.1, // HP上限値の上の方
                hpMaxDown: 10.95, // HP上限値の下の方
                hpDepth: 100,// HP奥行
                ptDepth: 100,// PT奥行
                ptTime: 175, // PT初期値
                cx: 0, // 円x初期値
                cy: 0, //円y初期値
                ptDepthCheck: false, // pt奥行絞り込チェックボックス
                hpDepthCheck: false, // hp奥行絞り込チェックボックス
            })

            // PT2H選択された投球1,2
            this.$ls.set(this.setting.sessionKey.pt2ConfirmationChangeAmountBall1, {})
            this.$ls.set(this.setting.sessionKey.pt2ConfirmationChangeAmountBall2, {})
            // 変化量選定のゾーン等
            this.$ls.set(this.setting.sessionKey.pt2HomeBallContent, {
                selectedZone: [],
                renderBall1: [],
                renderBall2: [],
                thresholdBall2: [],
                dataLoadFlag: false,
            })

            //PT2S シークバー
            this.$ls.set(this.setting.sessionKey.pt2S1ThresholdSeekBar, {
                ptX: 14.6, // PT円の横幅
                ptY: 14.6, // PT円の縦幅
                hpY: 51.1, // HP円の縦幅
                hpX: 51.1, // HP円の横幅
                ptMaxUp: 29.2, //PT上限値の上の方
                ptMaxDown: 3.65, // PT上限値の下の方
                hpMaxUp: 51.1, // HP上限値の上の方
                hpMaxDown: 10.95, // HP上限値の下の方
                hpDepth: 100,// HP奥行
                ptDepth: 100,// PT奥行
                pt: 175, // PT初期値
                cx: 0, // 円x初期値
                cy: 0, //円y初期値
                ptDepthCheck: false, // pt奥行絞り込チェックボックス
                hpDepthCheck: false, // hp奥行絞り込チェックボックス
            })

            // PT2S 選択された投球1,2
            this.$ls.set(this.setting.sessionKey.pt2SSelectedBall1, [])
            this.$ls.set(this.setting.sessionKey.pt2SSelectedBall2, [])

            // 検索コンポーネント関連
            this.$ls.set(this.setting.sessionKey.pt2Search, {})
            this.$ls.set(this.setting.sessionKey.pt2SearchTmp, {})
        },
        addSavedBalls () {
            let duplicate = false
            let data = this.ball
            let savedBalls = this.$ls.get('savedBalls',[])
            if (savedBalls.length >= 20) {
                this.$root.$emit('messageModalOn','比較球が20球登録されています。')
                return
            }
            savedBalls.forEach(function (d, i) {
                if (d.data.id === data.data.id) {
                    duplicate = true
                }
            })
            if (duplicate) {
                this.$alert('すでに登録済みの投球です。')
            } else {
                data = savedBalls.concat(data)
                this.$ls.set('savedBalls', data)
                this.getSavedBalls()
                this.$alert('投球を比較リストに追加しました。')
            }
        },
        getSavedBalls () {
            this.$emit('get-saved-balls')
        },
        getResultText (result, hit) {
            let text = ''
            if (result === 'Undefined' && hit === 'Undefined') {
                return '-'
            }
            if (result === 'InPlay') {
                if (this.setting.typesOfResult['InPlay'][hit] !== undefined) {
                    text = this.setting.typesOfResult['InPlay'][hit].name
                } else {
                    text = '-'
                }
            } else {
                if (this.setting.typesOfResult[result] !== undefined) {
                    text = this.setting.typesOfResult[result].name
                } else {
                    text = result
                }
            }
            return text
        },
        openSearchModal (type) {
            this.$emit('open-search-modal', type)
        },
        toggleSavedStandardBall (bool) {
            this.$emit('toggle-saved-standard-ball', bool, 0)
        },
        changeWard (ward) {
            if (ward === 'forward') {
                if (this.currentBatterPointSet.slideBatPositionZMin < this.slideBatz) {
                    this.currentParamsz -= 1
                }
            } else if (ward === 'backward') {
                if (this.currentBatterPointSet.slideBatPositionZMax > this.slideBatz) {
                    this.currentParamsz += 1
                }
            } else if (ward === 'leftward') {
                if (this.currentBatterPointSet.slideBatPositionXMin < this.slideBatx) {
                    this.currentParamsx -= 1
                }
            } else if (ward === 'rightward') {
                if (this.currentBatterPointSet.slideBatPositionXMax > this.slideBatx) {
                    this.currentParamsx += 1
                }
            }
            this.$emit('change-ward', ward)
        },
        changeBatterPoint () {
            this.currentParamsy = this.slideParamsy1
            this.$emit('change-batter-point', this.slideParamsy1)
        },
        changePitcherPosition () {
            this.currentParamsx2 = this.slideParamsx2
            this.$emit('change-pitcher-position', -1 * this.slideParamsx2)
        },
        changePitcherPoint () {
            this.currentParamsy2 = this.slideParamsy2
            this.$emit('change-pitcher-point', this.slideParamsy2)
        },
        removeSavedStandardBall () {
            let savedBalls = this.$ls.get('savedStandardBalls')
            if (savedBalls.length > 0) {
                savedBalls = []
                this.$ls.set('savedStandardBalls', savedBalls)
                this.getSavedStandardBalls()
                this.$alert('基準球を解除しました。')
                this.$parent.currentSavedStandardBallId = []
            }
        },
        getSavedStandardBalls () {
            console.log('getSavedStandardBalls')
            this.$emit('get-saved-standard-balls')
        },
        changeSlideParams () {
            this.slideParamsx1 = this.slideBatx
            this.slideParamsy1 = this.slideBaty
            this.slideParamsz1 = this.slideBatz
            this.slideParamsx2 = this.slidePitx
            this.slideParamsy2 = this.slidePity
            this.slideParamsz2 = this.slidePitz
            this.defaultParamsx1 = this.slideBatx
            this.defaultParamsy1 = this.slideBaty
            this.defaultParamsz1 = this.slideBatz
            this.defaultParamsx2 = this.slidePitx
            this.defaultParamsy2 = this.slidePity
            this.defaultParamsz2 = this.slidePitz
        },
        resetSlideParams () {
            this.slideParamsx1 = this.defaultParamsx1
            this.slideParamsz1 = this.defaultParamsz1
            this.currentParamsx = 0
            this.currentParamsz = 0
            this.$emit('reset-ward', [this.slideParamsx1, this.slideParamsz1])
        },
        formatPitParams (num) {
            if (num < 0) {
                return '左 ' + Math.abs(num)
            } else if (num > 0) {
                return '右 ' + Math.abs(num)
            } else {
                return num
            }
        },
        formatBatParamsz (num) {
            if (num < 0) {
                return '前 ' + Math.abs(num)
            } else if (num > 0) {
                return '後 ' + Math.abs(num)
            } else {
                return num
            }
        },
        formatBatParamsx (num) {
            if (num < 0) {
                return '左 ' + Math.abs(num)
            } else if (num > 0) {
                return '右 ' + Math.abs(num)
            } else {
                return num
            }
        },
        closeBatterPanel () {
            this.$emit('close-batter-panel')
        },
        closePitcherPanel () {
            this.$emit('close-pitcher-panel')
        },
        toggleBeforeAfterFlg (bool) {
            this.beforeAfterFlg = bool
        },
        toggleLeftRightFlg (bool) {
            this.leftRightFlg = bool
        },
        toggleLeftRightPitcherFlg (bool) {
            this.leftRightPitcherFlg = bool
        },
        changeBatterInputState (num) {
            if (num === 1) {
                this.beforeAfterFlg = this.currentParamsz > 0
                this.inputParamsz = Math.abs(this.currentParamsz)
                this.leftRightFlg = this.currentParamsx < 0
                this.inputParamsx = Math.abs(this.currentParamsx)
                this.inputDefaultParamsx = this.inputParamsx
                this.inputDefaultParamsz = this.inputParamsz
                this.defaultBeforeAfterFlg = this.beforeAfterFlg
                this.defaultLeftRightFlg = this.leftRightFlg
            } else if (num === 2) {
                this.inputParamsy = this.currentParamsy
                this.inputDefaultParamsy = this.inputParamsy
            }
            this.batterInputState = num
        },
        changePitcherInputState (num) {
            if (num === 1) {
                this.leftRightPitcherFlg = this.currentParamsx2 < 0
                this.inputParamsx2 = Math.abs(this.currentParamsx2)
                this.inputDefaultParamsx2 = this.inputParamsx2
                this.defaultLeftRightPitcherFlg = this.leftRightPitcherFlg
            } else if (num === 2) {
                this.inputParamsy2 = this.currentParamsy2
                this.inputDefaultParamsy2 = this.inputParamsy2
            }
            this.pitcherInputState = num
        },
        validBatterParamsz (e, val) {
            if (val !== 0 && !val) {
                this.inputParamsz = 0
            } else if (val < 0) {
                this.inputParamsz = 0
            }
            this.batterPositionValid()
        },
        validBatterParamsx (e, val) {
            if (val !== 0 && !val) {
                this.inputParamsx = 0
            } else if (val < 0) {
                this.inputParamsx = 0
            }
            this.batterPositionValid()
        },
        validBatterParamsy (e, val) {
            if (val !== 0 && !val) {
                this.inputParamsy = 160
            }
            this.batterPointValid()
        },
        validPitcherParamsx (e, val) {
            if (val !== 0 && !val) {
                this.inputParamsx2 = 0
            } else if (val < 0) {
                this.inputParamsx2 = 0
            }
            this.pitcherPositionValid()
        },
        validPitcherParamsy (e, val) {
            if (val !== 0 && !val) {
                this.inputParamsy2 = 160
            }
            this.pitcherPointValid()
        },
        batterPositionValid () {
            let validCount = 0
            let valid = false
            if (this.beforeAfterFlg) {
                if (this.inputParamsz > 10) {
                    validCount++
                }
            } else if (!this.beforeAfterFlg) {
                if (this.inputParamsz > 100) {
                    validCount++
                }
            }
            if (this.currentAngle === 'batterLeft') {
                if (this.leftRightFlg) {
                    if (this.inputParamsx > 70) {
                        validCount++
                    }
                } else if (!this.leftRightFlg) {
                    if (this.inputParamsx > 10) {
                        validCount++
                    }
                }
            } else if (this.currentAngle === 'batterRight') {
                if (this.leftRightFlg) {
                    if (this.inputParamsx > 30) {
                        validCount++
                    }
                } else if (!this.leftRightFlg) {
                    if (this.inputParamsx > 40) {
                        validCount++
                    }
                }
            }
            if (validCount > 0) {
                valid = true
            }
            this.batterPositionIsValid = valid
        },
        batterPointValid () {
            let validCount = 0
            let valid = false
            if (this.inputParamsy > 200) {
                validCount++
            } else if (this.inputParamsy < 160) {
                validCount++
            }
            if (validCount > 0) {
                valid = true
            }
            this.batterPointIsValid = valid
        },
        pitcherPositionValid () {
            let validCount = 0
            let valid = false
            if (this.leftRightPitcherFlg) {
                if (this.inputParamsx2 > 30) {
                    validCount++
                }
            } else if (!this.leftRightPitcherFlg) {
                if (this.inputParamsx2 > 30) {
                    validCount++
                }
            }
            if (validCount > 0) {
                valid = true
            }
            this.pitcherPositionIsValid = valid
        },
        pitcherPointValid () {
            let validCount = 0
            let valid = false
            if (this.inputParamsy2 > 200) {
                validCount++
            } else if (this.inputParamsy2 < 160) {
                validCount++
            }
            if (validCount > 0) {
                valid = true
            }
            this.pitcherPointIsValid = valid
        },
        submitBatterPosition () {
            let x = this.inputParamsx
            let z = this.inputParamsz
            x = this.leftRightFlg ? -1 * x : x
            z = this.beforeAfterFlg ? z : -1 * z
            this.$emit('submit-batter-position', this.defaultParamsx1 + x, this.defaultParamsz1 + z)
            this.currentParamsx = x
            this.currentParamsz = z
            this.changeBatterInputState(0)
        },
        submitBatterPoint () {
            let y = this.inputParamsy
            this.$emit('submit-batter-point', y)
            this.currentParamsy = y
            this.slideParamsy1 = y
            this.changeBatterInputState(0)
        },
        submitPitcherPosition () {
            let x = this.inputParamsx2
            x = this.leftRightPitcherFlg ? -1 * x : x
            this.$emit('submit-pitcher-position', this.defaultParamsx2 + x)
            this.currentParamsx2 = x
            this.slideParamsx2 = x
            this.changePitcherInputState(0)
        },
        submitPitcherPoint () {
            let y = this.inputParamsy2
            this.$emit('submit-pitcher-point', y)
            this.currentParamsy2 = y
            this.slideParamsy2 = y
            this.changePitcherInputState(0)
        },
        resetBatterPosition () {
            this.inputParamsx = this.inputDefaultParamsx
            this.inputParamsz = this.inputDefaultParamsz
            this.beforeAfterFlg = this.defaultBeforeAfterFlg
            this.leftRightFlg = this.defaultLeftRightFlg
        },
        resetBatterPoint () {
            this.inputParamsy = this.inputDefaultParamsy
        },
        resetPitcherPosition () {
            this.inputParamsx2 = this.inputDefaultParamsx2
            this.leftRightPitcherFlg = this.defaultLeftRightPitcherFlg
        },
        resetPitcherPoint () {
            this.inputParamsy2 = this.inputDefaultParamsy2
        },
        blurAfter () {
            $('body').scrollTop(0)
        }
    }
}
</script>
